import Vue from "vue";
import Plugin from "@quasar/quasar-ui-qcalendar";
import "@quasar/quasar-ui-qcalendar/dist/index.css";

Vue.use(Plugin);
